/**
 * Concern is a base class for Rails-like concern definitions, which can be included on Model classes.
 *
 * A Concern is used to add new fields and static properties to a Model, without needing to define those
 * properties on every applicable Model class itself.
 *
* This allows us to define and expect a base set of properties for all Models that support a given functionality.
 */
export default class Concern {
  static define () {
    // Does nothing by default
  }

  static get staticProperties () {
    if (_.isNil(this._cachedStaticProperties)) {
      this._cachedStaticProperties = _.difference(
        Object.getOwnPropertyNames(this),
        Object.getOwnPropertyNames(Object),
        [
          '_cachedStaticProperties',
          '_cachedInstanceMethods',
          'define',
          'fields',
          'computed',
          'watchers',
          'queries',
          'mutations'
        ]
      )
    }
    return this._cachedStaticProperties
  }

  static get instanceMethods () {
    if (_.isNil(this._cachedInstanceMethods)) {
      this._cachedInstanceMethods = _.difference(
        Object.getOwnPropertyNames(this.prototype),
        ['constructor']
      )
    }
    return this._cachedInstanceMethods
  }
}
